import { OrganizationYearSummary } from './organization-year-summary/OrganizationYearSummary';
import { isOrganizationIdrettslag } from '../../organization-model';
import OrganizationStatistics from './OrganizationStatistics';
import { useEffect } from 'react';
import { trackPageView } from '../../../support-and-tracking/analytics-actions';
import { useTitle } from 'hoofd';
import { Heading1 } from '@sb1/ffe-core-react';
import { Lead } from '../../../components/typography/Heading';
import { OrganizationControlFeedback } from '../../../components/feedback/OrganizationControlFeedback';
import { useOutletContext } from 'react-router';
import { useBackgroundColor } from '../useBackgroundColor';
import { THEMES } from '../../../utils/cms-utils';
import styles from './organization-statistics-overview.module.less';

const OrganizationStatisticsOverview = () => {
    const { organization } = useOutletContext();
    useBackgroundColor(THEMES.SAND30);

    useEffect(() => {
        trackPageView({
            urlAsEvent: 'organization-statistics',
        });
    }, []);

    useTitle('Rapporter');

    return (
        <>
            <div className={styles.headerWrapper}>
                <Heading1>Rapporter</Heading1>
                <Lead>
                    Få oversikt over hvordan det går på Spleis, ta et dypdykk ned i statistikken og hent ut rapporter
                </Lead>
            </div>
            <OrganizationYearSummary
                organizationId={organization.id}
                organizationName={organization.name}
                isOrgIdrettslag={isOrganizationIdrettslag(organization)}
                hasAcceptedRecurringPayment={!!organization?.profile?.acceptRecurringPayment}
            />
            <OrganizationStatistics organization={organization} />
            <OrganizationControlFeedback />
        </>
    );
};

export default OrganizationStatisticsOverview;
